import { render, staticRenderFns } from "./AboutMedia.vue?vue&type=template&id=644129a4&"
import script from "./AboutMedia.vue?vue&type=script&lang=js&"
export * from "./AboutMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports